import React, { useState, useEffect } from 'react';
import apiService from '../config';
import { Plus, Eye, MapPin, User, Calendar, IndianRupee, FileText, X, Send, Users, no_of_home, TreePine, Edit, Save, Check, Trash2, Filter, ChevronDown, ChevronUp, Globe, ArrowLeft } from 'lucide-react';
import ViewMeasurementList from './ViewMeasurementList';
import { toast } from 'react-toastify';
import Section19 from './Section19';
import { useLanguage } from '../StoreContext/LanguageContext';

const MeasurementList = ({ onBack, setSubComponent, setSelectedComponent, subComponent }) => {
  useEffect(() => { console.log('///////////////////', localStorage.userData); }, [])

  const [measurements, setMeasurements] = useState([]);
  const [selectedMeasurement, setSelectedMeasurement] = useState(null);
  const [loading, setLoading] = useState(false);
  const { language, translations } = useLanguage();
  const [proposalData, setProposalData] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedTaluka, setSelectedTaluka] = useState('');
  const [selectedVillage, setSelectedVillage] = useState('');
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [loadingTalukas, setLoadingTalukas] = useState(false);
  const [loadingVillages, setLoadingVillages] = useState(false);
  const [loadingMeasurements, setLoadingMeasurements] = useState(false);
  const [message, setMessage] = useState('');
  const [selectedLandAcquisitionId, setSelectedLandAcquisitionId] = useState(null);
  const [landAcquisitionId, setLandAcquisitionId] = useState(null);
  const [currentProjectId, setCurrentProjectId] = useState(null);
  const [currentProjectName, setCurrentProjectName] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [hasSentBackToSLR, setHasSentBackToSLR] = useState(false);
  const [hasSentToLAO, setHasSentToLAO] = useState(false);
  const [showSendToLAOModal, setShowSendToLAOModal] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [remarks, setRemarks] = useState('Approved');
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [sendingToLAO, setSendingToLAO] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);
  const [hasSentToSurveyor, setHasSentToSurveyor] = useState(false);
  const [hasSentBackToLAO, setHasSentBackToLAO] = useState(false);
  const [showSendToSLRModal, setShowSendToSLRModal] = useState(false);
  const [showSendToSurveyorModal, setShowSendToSurveyorModal] = useState(false);
  const [showSendbackToSLrModal, setShowSendbackToSLrModal] = useState(false);
  const [filteredMeasurements, setFilteredMeasurements] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [currentProposalId, setCurrentProposalId] = useState(null);
  const [showSendToAgencyDropdown, setShowSendToAgencyDropdown] = useState(false);
  const [showSendToAgencyDocument, setShowSendToAgencyDocument] = useState(false);
  const [showSendToAgencyModal, setShowSendToAgencyModal] = useState(false);
  const [sendingToAgency, setSendingToAgency] = useState(false);
  const [showSection19, setShowSection19] = useState(false);
  const [showSection19Modal, setShowSection19Modal] = useState(false);

  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [onConfirmAction, setOnConfirmAction] = useState(null);
  const [showSurveyorConfirmModal, setShowSurveyorConfirmModal] = useState(false);
  const [hasAssignedToSurveyor, setHasAssignedToSurveyor] = useState(false);
  const [hasFirstSentToLAO, setHasFirstSentToLAO] = useState(false);
  const [hasFirstSentToSurveyor, setHasFirstSentToSurveyor] = useState(false);
  const [hasFirstSentToDSLR, setHasFirstSentToDSLR] = useState(false);
  const [hasFirstSentToAgency, setHasFirstSentToAgency] = useState(false);


  const [showAlertModal, setShowAlertModal] = useState(false);
  const [alertConfig, setAlertConfig] = useState({
    title: '',
    message: '',
    type: 'success'
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [confirmConfig, setConfirmConfig] = useState({
    title: '',
    message: '',
    onConfirm: null,
    onCancel: null,
    type: 'warning'
  });

  // NEW: Send Back Modal States
  const [showSendBackToLAOModal, setShowSendBackToLAOModal] = useState(false);
  const [showSendBackToDSLRModal, setShowSendBackToDSLRModal] = useState(false);

  // ADD THESE HELPER FUNCTIONS HERE:
  const showAlert = (title, message, type = 'info') => {
    setAlertConfig({ title, message, type });
    setShowAlertModal(true);

    // Don't auto-hide success messages so user can see them
    if (type !== 'success') {
      setTimeout(() => setShowAlertModal(false), 5000);
    }
  };

  const showConfirm = (title, message, onConfirm, onCancel = null, type = 'warning') => {
    setConfirmConfig({ title, message, onConfirm, onCancel, type });
    setShowConfirmModal(true);
  };

  // NEW: Filter mode and panel states
  const [filterMode, setFilterMode] = useState('all'); // 'location' or 'all'
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  // Pre-modal for DSLR / Surveyor role
  const [showRoleModal, setShowRoleModal] = useState(false);
  const [roleFormData, setRoleFormData] = useState({});
  const [roleFile, setRoleFile] = useState(null);

  // Updated role constants
  const USER_ROLES = {
    SURVEYOR: 7,
    LAO: 3,
    DSLR: 15,
    AGENCY: 21,
    SAMANVAY: 6,
    COLLECTOR: 1
  };
  const currentUserRole = 7;
  const isSurveyor = currentUserRole === USER_ROLES.SURVEYOR;

  // Helper function to check if all filters are selected
  const hasValidLocationSelection = selectedDistrict;

  // NEW: Helper function to check if data can be shown
  const canShowData = filterMode === 'all' || (filterMode === 'location' && hasValidLocationSelection);

  // Helper function to get current location description
  const getCurrentLocationDescription = () => {
    if (filterMode === 'all') {
      return 'All Locations';
    }

    if (selectedDistrict && selectedTaluka && selectedVillage) {
      return `Village: ${selectedVillage}, ${selectedTaluka}, ${selectedDistrict}`;
    } else if (selectedDistrict && selectedTaluka) {
      return `Taluka: ${selectedTaluka}, ${selectedDistrict}`;
    } else if (selectedDistrict) {
      return `District: ${selectedDistrict}`;
    } else {
      return 'No location selected';
    }
  };

  const refetchMeasurements = async () => {
    if (!currentProjectId && !proposalId) {
      return;
    }

    setLoadingMeasurements(true);

    try {
      const districtName = districts.find(d => d.dist_name === selectedDistrict)?.name || selectedDistrict || null;
      const talukaName = talukas.find(t => t.taluka_name === selectedTaluka)?.taluka_name || selectedTaluka || null;
      const villageName = villages.find(v => v.village_name === selectedVillage)?.village_name || selectedVillage || null;

      const result = await apiService.getMeasurement(
        districtName,
        talukaName,
        villageName,
        currentProjectId,
        { proposalId: proposalId }
      );

      if (result.status === 200 && result.data) {
        const processedData = result.data.flatMap(item => {
          const measurements = item.measurements || [item];
          return measurements.map(measurement => ({
            ...measurement,
            project_name: item.project_name || measurement.project_name,
            landholder_name: item.landholder_name || measurement.landholder_name,
            survey_no: Array.isArray(item.survey_no)
              ? item.survey_no.join(', ')
              : (item.survey_no || measurement.survey_no || measurement.surveyNo),
            owner_name: measurement.owner_name || item.landholder_name || measurement.landholder_name,
            LandAcquisition_id: measurement.LandAcquisition_id || item.LandAcquisition_id,
            land_owner_id: measurement.land_owner_id || measurement.id,
            is_SLRVerified: measurement.is_SLRVerified,
            is_surveyorVerified: measurement.is_surveyorVerified
          }));
        });

        setMeasurements(processedData);
      } else {
        setMeasurements([]);
      }
    } catch (error) {
      console.error('Error refetching measurements:', error);
      setMeasurements([]);
    } finally {
      setLoadingMeasurements(false);
    }
  };

  // NEW: Load measurements for all locations
  const refetchAllMeasurements = async () => {
    if (!currentProjectId && !proposalId) {
      return;
    }

    setLoadingMeasurements(true);

    try {
      console.log('🔍 Loading ALL measurement data for project:', currentProjectId, 'proposal:', proposalId);

      // Call API without location filters to get all measurements
      const result = await apiService.getMeasurement(
        null, // districtName
        null, // talukaName  
        null, // villageName
        currentProjectId,
        { proposalId: proposalId }
      );

      if (result.status === 200 && result.data) {
        const processedData = result.data.flatMap(item => {
          const measurements = item.measurements || [item];
          return measurements.map(measurement => ({
            ...measurement,
            project_name: item.project_name || measurement.project_name,
            landholder_name: item.landholder_name || measurement.landholder_name,
            survey_no: Array.isArray(item.survey_no)
              ? item.survey_no.join(', ')
              : (item.survey_no || measurement.survey_no || measurement.surveyNo),
            owner_name: measurement.owner_name || item.landholder_name || measurement.landholder_name,
            LandAcquisition_id: measurement.LandAcquisition_id || item.LandAcquisition_id,
            land_owner_id: measurement.land_owner_id || measurement.id,
            is_SLRVerified: measurement.is_SLRVerified,
            is_surveyorVerified: measurement.is_surveyorVerified,
            // Add location info for all records view
            district: item.dist_name || measurement.district,
            taluka: item.taluka_name || measurement.taluka,
            village: item.village_name || measurement.village,
          }));
        });

        setMeasurements(processedData);
        console.log('✅ All measurement data loaded successfully:', processedData.length, 'records');

      } else {
        setMeasurements([]);
      }
    } catch (error) {
      console.error('❌ Error loading all measurement data:', error);
      setMeasurements([]);
    } finally {
      setLoadingMeasurements(false);
    }
  };

  const getVerifiedLandAcquisitionIds = (measurements, userRole) => {
    let targetMeasurements = [];

    if (userRole === USER_ROLES.DSLR) {
      // For DSLR, get measurements that are SLR verified (to send back to LAO)
      targetMeasurements = measurements.filter(m => m.is_SLRVerified === true);
    } else if (userRole === USER_ROLES.SURVEYOR) {
      // For Surveyor, get measurements that are surveyor verified (to send back to DSLR)
      targetMeasurements = measurements.filter(m => m.is_surveyorVerified === true);
    }

    const targetIds = targetMeasurements
      .map(item => item.LandAcquisition_id)
      .filter(id => id !== null && id !== undefined && id !== '') // Remove null/undefined/empty values
      .filter((id, index, array) => array.indexOf(id) === index); // Remove duplicates

    return targetIds.join(',');
  };

  // Add this state declaration with your other useState calls:
  const [userRole, setUserRole] = useState(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        const user = JSON.parse(userData);
        return user.user_role || null;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
    }
    return null;
  });

  useEffect(() => {
    if (currentProjectId && proposalId) {

      fetchUsers();
      console.log("Surveyor API IDs →", currentProjectId, proposalId);

    }
  }, [currentProjectId, proposalId, userRole]);

  // 🔧 Auto-load users & seed today’s date when Role Pre-Modal opens
  useEffect(() => {
    if (!showRoleModal) return;

    if (userRole === USER_ROLES.DSLR) {
      fetchUsers(); // populates Surveyor dropdown
    } else if (userRole === USER_ROLES.SURVEYOR) {
      fetchUsersSlr(); // populates SLR dropdown
    }

    const today = new Date().toISOString().slice(0, 10);
    setRoleFormData(prev => ({
      ...prev,
      dlsr_survey_application_date: prev.dlsr_survey_application_date || today,
      dlsr_gov_fee_payment_date: prev.dlsr_gov_fee_payment_date || today,
      surveyor_joint_survey_start_date: prev.surveyor_joint_survey_start_date || today,
      surveyor_joint_survey_end_date: prev.surveyor_joint_survey_end_date || today,
    }));
  }, [showRoleModal, userRole, currentProjectId, proposalId]);

  // for dtes in showrolemodal
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    setRoleFormData(prev => ({
      ...prev,
      dlsr_survey_application_date: today,
      dlsr_gov_fee_payment_date: today,
      surveyor_joint_start_date: today,
      surveyor_joint_end_date: today
    }));
  }, []);

  const fetchUsers = async () => {
    const role = 7; // Surveyor role
    setLoadingUsers(true);
    try {
      const response = await apiService.getAllUserRoleSurveyor(7, currentProjectId, proposalId);
      console.log('Users response:', response);
      if (response.status === 200 && response.data) {
        setUsers(Array.isArray(response.data) ? response.data : []);
        return { success: true };
      }
      return { success: false };
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchUsersSlr = async () => {
    setLoadingUsers(true);
    try {
      const response = await apiService.getAllUserRoleDSLR(15, currentProjectId, proposalId);
      console.log('Users response:', response);
      if (response.status === 200 && response.data) {
        setUsers(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const fetchUserslao = async () => {
    setLoadingUsers(true);
    try {
      const role = 3;
      const response = await apiService.getAssignLAO(role, currentProjectId, proposalId);
      console.log('Users response:', response);
      if (response.status === 200 && response.data) {
        setUsers(Array.isArray(response.data) ? response.data : []);
      }
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsers([]);
    } finally {
      setLoadingUsers(false);
    }
  };

  const handleViewDocument = (file) => {
    const url = URL.createObjectURL(file);
    setDocumentUrl(url);
    setShowModal(true);
  };

  const handleSendToSLR = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // Get only verified land acquisition IDs
    const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

    if (!verifiedLandAcquisitionIds) {
      toast.error('No verified measurements found to send', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      const response = await apiService.postTrackingSLR(formData);
      console.log('Send to SLR response:', response);

      if (response.status === 200) {
        // 🔥 CHANGED: Show toast AFTER successful API call
        toast.success('Successfully sent verified measurements to DSLR Officer!', {
          duration: 4000,
          position: 'top-right',
        });

        setHasFirstSentToLAO(true); // 🔥 SET RED FLAG
        setShowSendToSLRModal(false)

        // Reset form
        setShowSendToSLRModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);
        setHasFirstSentToLAO(true);
        setShowSendToSLRModal(false);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());

      } else {
        toast.error('Failed to send to DSLR Officer. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error sending to DSLR:', error);
      toast.error('Error occurred while sending to DSLR. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  // REPLACE your handleSendToSurveyor function with this:
  const handleSendToSurveyor = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // Get ALL unassigned measurements (not verified ones)
    const unassignedMeasurements = measurements.filter(m =>
      m.is_SLRVerified === null && m.is_surveyorVerified === null
    );

    if (unassignedMeasurements.length === 0) {
      toast.error('No unassigned measurements found to assign to surveyor', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // Get all unassigned land acquisition IDs
    const unassignedLandAcquisitionIds = unassignedMeasurements
      .map(item => item.LandAcquisition_id)
      .filter(id => id !== null && id !== undefined && id !== '')
      .filter((id, index, array) => array.indexOf(id) === index)
      .join(',');

    // const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    // const projectId = selectedProject?.id || selectedProject?.project_id;

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', unassignedLandAcquisitionIds);

      const response = await apiService.postTrackingSurveyor(formData);
      console.log('Send to Surveyor response:', response);

      if (response.status === 200) {
        toast.success('Successfully assigned measurements to Surveyor!', {
          duration: 4000,
          position: 'top-right',
        });


        // 🔥 NEW: Set flag after successful assignment
        setHasSentToSurveyor(true);
        setHasAssignedToSurveyor(true);
        setHasFirstSentToSurveyor(true); // 🔴 Turn button red for future sends
        setShowSendToSurveyorModal(false);

        // Reset form
        setShowSendToSurveyorModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());


      } else {
        toast.error('Failed to assign to Surveyor. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error assigning to Surveyor:', error);
      toast.error('Error occurred while assigning to Surveyor. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  const handleSendBackToLao = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // Get only verified land acquisition IDs
    const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

    if (!verifiedLandAcquisitionIds) {
      toast.error('No verified measurements found to send', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
    // const projectId = selectedProject?.id || selectedProject?.project_id;

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      const response = await apiService.postTrackingbacktoLao(formData);
      console.log('Send back to LAO response:', response);

      if (response.status === 200) {
        toast.success('Successfully sent verified measurements back to LAO!', {
          duration: 4000,
          position: 'top-right',
        });

        setHasFirstSentToLAO(true);
        setShowSendBackToLAOModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());
      } else {
        toast.error('Failed to send to LAO Officer. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error sending back to LAO:', error);
      toast.error('Error occurred while sending to LAO. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  const handleSendBackToSlr = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    // Get only verified land acquisition IDs
    const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

    if (!verifiedLandAcquisitionIds) {
      toast.error('No completed measurements found to send', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      const response = await apiService.postTrackingbacktoSlr(formData);
      console.log('Send back to DSLR response:', response);

      if (response.status === 200) {
        // 🔥 CHANGED: Show toast AFTER successful API call
        toast.success('Successfully sent completed measurements to DSLR!', {
          duration: 4000,
          position: 'top-right',
        });

        setHasFirstSentToDSLR(true);
        setShowSendbackToSLrModal(false);

        // Reset form
        setShowSendbackToSLrModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());

      } else {
        toast.error('Failed to send to DSLR Officer. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error sending back to DSLR:', error);
      toast.error('Error occurred while sending to DSLR. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  // NEW: Send Back to LAO (from DSLR)
  const handleSendBackToLAO = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

    if (!verifiedLandAcquisitionIds) {
      toast.error('No verified measurements found to send back', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      const response = await apiService.postTrackingbacktoLao(formData);

      if (response.status === 200) {
        toast.success('Successfully sent verified measurements back to LAO!', {
          duration: 4000,
          position: 'top-right',
        });

        setHasFirstSentToLAO(true);
        setShowSendBackToLAOModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());
      } else {
        toast.error('Failed to send back to LAO Officer. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error sending back to LAO:', error);
      toast.error('Error occurred while sending back to LAO. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  // NEW: Send Back to DSLR (from Surveyor)
  const handleSendBackToDSLR = async () => {
    if (!selectedUser || !selectedDocument) {
      toast.error('Please select a user and upload a document', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    const verifiedLandAcquisitionIds = getVerifiedLandAcquisitionIds(measurements, userRole);

    if (!verifiedLandAcquisitionIds) {
      toast.error('No completed measurements found to send back', {
        duration: 4000,
        position: 'top-right',
      });
      return;
    }

    setSendingToLAO(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      const response = await apiService.postTrackingbacktoSlr(formData);

      if (response.status === 200) {
        toast.success('Successfully sent completed measurements back to DSLR!', {
          duration: 4000,
          position: 'top-right',
        });

        setShowSendBackToDSLRModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());
      } else {
        toast.error('Failed to send back to DSLR Officer. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }
    } catch (error) {
      console.error('Error sending back to DSLR:', error);
      toast.error('Error occurred while sending back to DSLR. Please try again.', {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setSendingToLAO(false);
    }
  };

  const handleSendToAgency = async () => {
    if (!selectedUser || !selectedDocument) {
      showAlert('Please select a user and upload a document');
      return;
    }

    const verifiedMeasurements = measurements.filter(m =>
      m.is_surveyorVerified === true
    );

    const verifiedLandAcquisitionIds = verifiedMeasurements
      .map(item => item.LandAcquisition_id)
      .filter(id => id !== null && id !== undefined && id !== '')
      .filter((id, index, array) => array.indexOf(id) === index)
      .join(',');

    if (!verifiedLandAcquisitionIds) {
      showAlert('No verified measurements found to send to agency. Please ensure measurements are completed by both surveyor and DSLR.');
      return;
    }

    console.log('Sending verified land acquisition IDs to agency:', verifiedLandAcquisitionIds);
    console.log('Number of verified measurements:', verifiedMeasurements.length);

    setSendingToAgency(true);
    try {
      const formData = new FormData();
      formData.append('project_id', currentProjectId);
      formData.append('proposal_id', proposalId);
      formData.append('remarks', remarks);
      formData.append('usr_id', selectedUser);
      formData.append('document', selectedDocument);

      // ✅ Use the verified land acquisition IDs
      formData.append('landAqusition_id', verifiedLandAcquisitionIds);

      // ✅ Call the API
      const response = await apiService.postTrackingAgency(formData, 'Agency');

      if (response.status === 200) {
        toast.success('Successfully sent measurements to Agency', {
          duration: 4000,
          position: 'top-right',

        });

        setHasFirstSentToAgency(true);
        // 🔥 SET RED FLAG
        setShowSendToAgencyModal(false);
        // setShowSendToAgencyModal(false);
        // setShowSendbackToSLrModal(false);
        setSelectedUser('');
        setRemarks('Approved');
        setSelectedDocument(null);

        await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());

      } else {
        toast.error("Failed to send to agency");
      }
    } catch (error) {
      console.error("Error in sending to agency:", error);
      toast.error("Error occurred while sending");
    } finally {
      setSendingToAgency(false);
    }
  };

  const openAgencyModal = async () => {
    try {
      setLoadingUsers(true);
      const res = await apiService.getAllUserRoleAgency(21, currentProjectId, proposalId); // role = 21
      if (res.status === 200) {
        setUsers(res.data || []);
        setShowSendToAgencyModal(true);
      }
    } catch (error) {
      console.error('Failed to fetch agency users:', error);
    } finally {
      setLoadingUsers(false);
    }
  };

  //   // Get project ID and name from localStorage or context
  //   useEffect(() => {
  //     const getProjectInfo = () => {
  //       const savedProposalId = localStorage.getItem('currentProposalId');
  //       if (savedProposalId) {
  //         setProposalId(savedProposalId);
  //       }
  //       if (!savedProposalId) {
  //         const userData = localStorage.getItem('userData');
  //         if (userData) {
  //           try {
  //             const user = JSON.parse(userData);
  //             const foundProposalId = user.proposal_id || user.data?.proposal_id;
  //             if (foundProposalId) {
  //               setProposalId(foundProposalId);
  //               localStorage.setItem('currentProposalId', foundProposalId);
  //             }
  //           } catch (e) {
  //             console.error('Error parsing user data for proposal ID:', e);
  //           }
  //         }
  //       }

  //       // Try to get from current project data first
  //       const currentProjectData = localStorage.getItem('currentProjectData');
  //       if (currentProjectData) {
  //         try {
  //           const projectData = JSON.parse(currentProjectData);
  //           return {
  //             id: projectData.project_id || projectData.id,
  //             name: projectData.project_name || projectData.name
  //           };
  //         } catch (e) {
  //           console.error('Error parsing current project data:', e);
  //         }
  //       }

  //       // Try to get from selected project in localStorage
  //       const selectedProject = localStorage.getItem('selectedProject');
  //       if (selectedProject) {
  //         try {
  //           const project = JSON.parse(selectedProject);
  //           return {
  //             id: project.project_id || project.id,
  //             name: project.project_name || project.name
  //           };
  //         } catch (e) {
  //           console.error('Error parsing selected project:', e);
  //         }
  //       }

  //       // Fallback to userData
  //       const userData = localStorage.getItem('userData');
  //       if (userData) {
  //         try {
  //           const user = JSON.parse(userData);
  //           return {
  //             id: user.data?.project_id || user.project_id,
  //             name: user.data?.project_name || user.project_name
  //           };
  //         } catch (e) {
  //           console.error('Error parsing user data:', e);
  //         }
  //       }

  //       return { id: null, name: null };
  //     };

  //     const projectInfo = getProjectInfo();
  //     setCurrentProjectId(projectInfo.id);
  //     setCurrentProjectName(projectInfo.name);
  // console.log("Sending with project_id:", currentProjectId, "proposal_id:", proposalId);

  //   }, []);

  useEffect(() => {
    const getProjectInfo = () => {
      const userData = localStorage.getItem("userData");
      let proposalFromUser = null;

      if (userData) {
        try {
          const user = JSON.parse(userData);
          proposalFromUser = user.default_proposal || user.data?.default_proposal || null;
        } catch (e) {
          console.error("Error parsing user data for proposal ID:", e);
        }
      }

      if (proposalFromUser) {
        setProposalId(proposalFromUser);
        localStorage.setItem("currentProposalId", proposalFromUser); // overwrite
      }

      // 🔹 Project info
      const currentProjectData = localStorage.getItem("currentProjectData");
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name,
          };
        } catch (e) {
          console.error("Error parsing current project data:", e);
        }
      }

      const selectedProject = localStorage.getItem("selectedProject");
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name,
          };
        } catch (e) {
          console.error("Error parsing selected project:", e);
        }
      }

      if (userData) {
        try {
          const user = JSON.parse(userData);
          return {
            id: user.data?.project_id || user.project_id,
            name: user.data?.project_name || user.project_name,
          };
        } catch (e) {
          console.error("Error parsing user data:", e);
        }
      }

      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setCurrentProjectId(projectInfo.id);
    setCurrentProjectName(projectInfo.name);
  }, []);

  useEffect(() => {
    if (currentProjectId && proposalId) {
      console.log("✅ Ready with project_id:", currentProjectId, "proposal_id:", proposalId);
    }
  }, [currentProjectId, proposalId]);



  // Separate effect only for logging updated values
  useEffect(() => {
    if (currentProjectId && proposalId) {
      console.log("✅ Ready with project_id:", currentProjectId, "proposal_id:", proposalId);
    }
  }, [currentProjectId, proposalId]);

  const handleViewDetails = (measurement) => {
    const landAcquisitionId = measurement?.LandAcquisition_id || measurement?.id;
    setSelectedLandAcquisitionId(landAcquisitionId);

    if (!landAcquisitionId) {
      showAlert('Land Acquisition ID not found');
      return;
    }

    // Store the measurement data for reference
    setSelectedMeasurement(measurement);

    setSubComponent('ViewMeasurementList', landAcquisitionId);
  };

  const handleVerification = async (measurement) => {
    try {
      setLoading(true);

      // Prepare verification payload
      const verificationPayload = {
        is_SLRVerified: 1
      };

      console.log('Verifying measurement with ID:', measurement.LandAcquisition_id);

      // Call the API using your existing apiService pattern
      const response = await apiService.patchUpdateLand(
        measurement.LandAcquisition_id, // measurementId
        verificationPayload,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      console.log('Verification API Response:', response);

      if (response?.status === 200) {
        // 🔥 CHANGED: Direct success message, no confirmation
        toast.success('Measurement verified successfully!', {
          duration: 4000,
          position: 'top-right',
        });

        // Update the local state to reflect the verification
        setMeasurements(prevMeasurements =>
          prevMeasurements.map(m =>
            m.LandAcquisition_id === measurement.LandAcquisition_id
              ? { ...m, is_SLRVerified: true }
              : m
          )
        );

        console.log('Measurement verified successfully');
      } else {
        toast.error('Failed to verify measurement. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }

    } catch (error) {
      console.error('Error verifying measurement:', error);

      // More detailed error handling
      let errorMessage = 'Error occurred while verifying measurement';
      if (error.response) {
        errorMessage += `: ${error.response.data?.message || error.response.statusText}`;
      } else if (error.message) {
        errorMessage += `: ${error.message}`;
      }

      toast.error(errorMessage, {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSurveyorVerification = async (measurement) => {
    try {
      setLoading(true);

      // Prepare verification payload
      const verificationPayload = {
        is_surveyorVerified: true
      };

      console.log('Completing measurement with ID:', measurement.LandAcquisition_id);

      // Call the API using your existing apiService pattern
      const response = await apiService.patchUpdateLand(
        measurement.LandAcquisition_id, // measurementId
        verificationPayload,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      console.log('Surveyor Verification API Response:', response);

      if (response?.status === 200) {
        // 🔥 CHANGED: Direct success message, no confirmation
        toast.success('Measurement completed successfully!', {
          duration: 4000,
          position: 'top-right',
        });

        // Update the local state to reflect the verification
        setMeasurements(prevMeasurements =>
          prevMeasurements.map(m =>
            m.LandAcquisition_id === measurement.LandAcquisition_id
              ? { ...m, is_surveyorVerified: true }
              : m
          )
        );

        console.log('Measurement completed successfully');
      } else {
        toast.error('Failed to complete measurement. Please try again.', {
          duration: 4000,
          position: 'top-right',
        });
      }

    } catch (error) {
      console.error('Error completing measurement:', error);

      // More detailed error handling
      let errorMessage = 'Error occurred while completing measurement';
      if (error.response) {
        errorMessage += `: ${error.response.data?.message || error.response.statusText}`;
      } else if (error.message) {
        errorMessage += `: ${error.message}`;
      }

      toast.error(errorMessage, {
        duration: 4000,
        position: 'top-right',
      });
    } finally {
      setLoading(false);
    }
  };

  // Updated useEffect for districts
  useEffect(() => {
    const fetchDistricts = async () => {
      setLoadingDistricts(true);
      try {
        const res = await apiService.getDistricts();
        setDistricts(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Failed to fetch districts:", error);
        setDistricts([]);
      } finally {
        setLoadingDistricts(false);
      }
    };
    fetchDistricts();
  }, []);

  // Updated useEffect for talukas
  useEffect(() => {
    const fetchTalukas = async () => {
      if (!selectedDistrict) {
        setTalukas([]);
        return;
      }

      setLoadingTalukas(true);
      try {
        const res = await apiService.getTalukas(selectedDistrict);
        setTalukas(Array.isArray(res.data) ? res.data : []);
      } catch (error) {
        console.error("Failed to fetch talukas:", error);
        setTalukas([]);
      } finally {
        setLoadingTalukas(false);
      }
    };
    fetchTalukas();
  }, [selectedDistrict]);

  // Updated useEffect for villages
  useEffect(() => {
    const fetchVillages = async () => {
      // FIX: Changed the condition - should fetch when BOTH district AND taluka are selected
      if (!selectedDistrict || !selectedTaluka) {
        setVillages([]);
        setSelectedVillage(''); // Reset village selection
        return;
      }

      setLoadingVillages(true);
      try {
        console.log('Calling getVillages with distNo:', selectedDistrict, 'tehsil_no:', selectedTaluka);
        const res = await apiService.getVillages(selectedDistrict, selectedTaluka);
        console.log('Villages API Response:', res);

        const villagesData = Array.isArray(res.data) ? res.data : [];
        setVillages(villagesData);

        // Reset village selection when new villages are loaded
        setSelectedVillage('');

      } catch (error) {
        console.error("Failed to fetch villages:", error);
        setVillages([]);
        setSelectedVillage('');
      } finally {
        setLoadingVillages(false);
      }
    };

    fetchVillages();
  }, [selectedDistrict, selectedTaluka]);

  // ✅ to fetch proposal to pre-fill send to surveyor and send back to dslr
  useEffect(() => {
    const fetchProposalData = async () => {
      try {
        if (!currentProjectId || !proposalId) return;
        const res = await apiService.getProposalById(currentProjectId, proposalId);
        if (res?.data) {
          const today = new Date().toISOString().split("T")[0];
          setProposalData(res.data);

          // also prefill modal form
          setRoleFormData({
            dlsr_appoint_surveyor: res.data.dlsr_appoint_surveyor || "",
            dlsr_survey_application_date: res.data.dlsr_survey_application_date
              ? res.data.dlsr_survey_application_date.split("T")[0]
              : "",
            dlsr_gov_fee_paid_for_survey: res.data.dlsr_gov_fee_paid_for_survey || "",
            dlsr_gov_fee_payment_date: res.data.dlsr_gov_fee_payment_date
              ? res.data.dlsr_gov_fee_payment_date.split("T")[0]
              : "",

            // SURVEYOR joint survey dates
            surveyor_joint_start_date: res.data.surveyor_joint_start_date
              ? res.data.surveyor_joint_start_date.split("T")[0]
              : (res.data.surveyor_joint_end_date
                ? res.data.surveyor_joint_end_date.split("T")[0]
                : today),
            surveyor_joint_end_date: res.data.surveyor_joint_end_date
              ? res.data.surveyor_joint_end_date.split("T")[0]
              : (res.data.surveyor_joint_start_date
                ? res.data.surveyor_joint_start_date.split("T")[0]
                : today),

            // ✅ Officials + MR No
            surveyor_present_officials_name_designation:
              res.data.surveyor_present_officials_name_designation || "",
            surveyor_m_r_no: res.data.surveyor_m_r_no || "",

            // ✅ Extra fields to send
            acquisition_agency: res.data.acquisition_agency || "",
            acquisition_purpose: res.data.acquisition_purpose || "",
            section_11_bhusampadan_no: res.data.section_11_bhusampadan_no || "",
          });
        }
      } catch (err) {
        console.error("Error fetching proposal data:", err);
      }
    };

    fetchProposalData();
  }, [currentProjectId, proposalId]);


  // UPDATED: Load measurements based on filter mode
  useEffect(() => {
    if (filterMode === 'all' && currentProjectId && proposalId) {
      refetchAllMeasurements();
    }
  }, [filterMode, currentProjectId, proposalId]);

  useEffect(() => {
    if (filterMode === 'location' && selectedDistrict && currentProjectId && proposalId) {
      refetchMeasurements();
    } else if (filterMode === 'location') {
      setMeasurements([]);
      setFilteredMeasurements([]);
    }
  }, [filterMode, selectedDistrict, selectedTaluka, selectedVillage, currentProjectId, proposalId]);


  useEffect(() => {
    const filtered = measurements.filter(m => {
      return (
        (!selectedDistrict || m.district === selectedDistrict) &&
        (!selectedTaluka || m.taluka === selectedTaluka) &&
        (!selectedVillage || m.village === selectedVillage)
      );
    });
    setFilteredMeasurements(filtered);
  }, [measurements, selectedDistrict, selectedTaluka, selectedVillage]);

  const handleDistrictChange = (e) => {
    const selectedDistrictId = e.target.value;
    setSelectedDistrict(selectedDistrictId);
    setSelectedTaluka('');
    setSelectedVillage('');
    setTalukas([]);
    setVillages([]);
  };

  const handleTalukaChange = (e) => {
    const selectedTalukaId = e.target.value;
    setSelectedTaluka(selectedTalukaId);
    setSelectedVillage('');
    setVillages([]);
    // Don't clear measurements here - let the useEffect handle it
  };

  const handleVillageChange = (e) => {
    const selectedVillageId = e.target.value;
    console.log('Village changed to:', selectedVillageId);
    setSelectedVillage(selectedVillageId);
    // Don't clear measurements here - let the useEffect handle it
  };

  const handleDeleteRecord = async (measurement) => {
    if (!measurement.LandAcquisition_id) {
      toast.error('Invalid record ID');
      return;
    }

    // Show confirmation dialog
    showConfirm(
      'Delete Record',
      'Are you sure you want to delete this measurement record? This action cannot be undone.',
      async () => {
        try {
          setLoading(true);

          // Call delete API - adjust the method name as per your API
          const response = await apiService.deleteMeasurement(measurement.LandAcquisition_id);

          if (response.status === 200) {
            toast.success('Record deleted successfully!', {
              duration: 4000,
              position: 'top-right',
            });

            // Refresh the measurements list
            await (filterMode === 'all' ? refetchAllMeasurements() : refetchMeasurements());
          } else {
            toast.error('Failed to delete record. Please try again.');
          }
        } catch (error) {
          console.error('Error deleting record:', error);
          toast.error('Error occurred while deleting record. Please try again.');
        } finally {
          setLoading(false);
        }
      },
      null,
      'danger'
    );
  };

  const handleSection21_1 = () => {
    console.log("Switching to Section21_1");
    setSubComponent('Section21_1');
  };
  const handleSection21_1_4 = () => {
    console.log("Switching to Section21_1_4");
    setSubComponent('Section21_1_4');
  };

  const confirmPartialVerification = (verifiedCount, totalCount, actionCallback) => {
    if (verifiedCount < totalCount) {
      setOnConfirmAction(() => actionCallback);
      setShowConfirmationModal(true);
    } else {
      actionCallback();
    }
  };

  if (showSection19) {
    return <Section19 onBack={() => setShowSection19(false)} />;
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      {/* Header with Filter Button */}
      <div className="bg-gradient-to-r from-gray-50 to-gray-100 border-b border-gray-200 shadow-sm">
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">

            <div className="flex items-center space-x-3">
              {/* Filter Button */}
              <button
                onClick={() => setShowFilterPanel(!showFilterPanel)}
                className={`flex items-center space-x-2 px-4 py-2.5 rounded-lg font-medium transition-all duration-200 shadow-sm hover:shadow-md ${showFilterPanel
                  ? 'bg-orange-600 text-white'
                  : 'bg-orange-600 text-white'
                  }`}
              >
                <Filter className="h-4 w-4" />
                <span>{translations[language].Filters}</span>
                {showFilterPanel ?
                  <ChevronUp className="h-4 w-4" /> :
                  <ChevronDown className="h-4 w-4" />
                }
              </button>

              {/* Action Buttons */}
              {userRole === USER_ROLES.LAO && (
                <div className="flex items-center gap-4">
                  {/* Send to Agency Button */}
                  <button
                    onClick={async () => {
                      const fullyVerified = measurements.filter(
                        m => m.is_surveyorVerified === true
                      ).length;
                      const total = measurements.length;

                      await confirmPartialVerification(fullyVerified, total, async () => {
                        await openAgencyModal();
                      });
                    }}
                    disabled={
                      measurements.filter(
                        (m) => m.is_surveyorVerified === true
                      ).length === 0
                    }
                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 whitespace-nowrap ${measurements.filter(
                      (m) => m.is_surveyorVerified === true
                    ).length === 0
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                      : hasFirstSentToAgency
                        ? 'bg-red-600 text-white hover:bg-red-700' // 🔥 RED after first send
                        : 'bg-indigo-600 text-white hover:bg-indigo-700' // 🔵 Blue for first send
                      }`}
                  >
                    <Send className="mr-2 h-5 w-5 flex-shrink-0" />
                    <span>
                      {hasFirstSentToAgency ? 'Re-send to' : 'Send All to'} {translations[language].ConcernValuer} ({
                        measurements.filter(
                          (m) => m.is_surveyorVerified === true
                        ).length
                      })
                    </span>
                  </button>



                </div>

              )}

              {/* Section 19 Button - Only for Samanvay, Collector, and LAO */}
              {(userRole === USER_ROLES.SAMANVAY || userRole === USER_ROLES.COLLECTOR || userRole === USER_ROLES.LAO) && (
                <button
                  onClick={() => setSelectedComponent('Section19')}
                  disabled={
                    measurements.filter(
                      (m) => m.is_SLRVerified === true && m.is_surveyorVerified === true
                    ).length === 0
                  }
                  className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 whitespace-nowrap
          ${measurements.filter(
                    (m) => m.is_SLRVerified === true && m.is_surveyorVerified === true
                  ).length === 0
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                      : 'bg-sky-700 text-gray-100 hover:bg-sky-800'
                    }
        `}
                >
                  <Send className="mr-2 h-5 w-5 flex-shrink-0" />
                  <span>Section 19</span>
                </button>
              )}

              {/* Section 21 */}
              <button
                onClick={() => handleSection21_1()}
                // disabled={!canShowData || landholdingData.length === 0}
                className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-medium">{translations[language].Section21_1}</span>
              </button>

              <button
                onClick={() => handleSection21_1_4()}
                // disabled={!canShowData || landholdingData.length === 0}
                className="px-5 py-3 text-sm bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white rounded-xl flex items-center space-x-2 transition-all duration-300 shadow-lg shadow-green-200 hover:shadow-green-300 group disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <FileText className="h-5 w-5 group-hover:scale-110 transition-transform duration-300" />
                <span className="font-medium">{translations[language].Section21_1_4}</span>
              </button>

              {userRole === USER_ROLES.SURVEYOR && (
                <div className="flex items-center gap-4">
                  {/* Send to LAO Button */}
                  {/* <button
                    onClick={async () => {
                      try {
                        const verifiedCount = measurements.filter(m => m.is_surveyorVerified === true).length;

                        if (verifiedCount > 0) {
                          setShowSendToLAOModal(true);
                          await fetchUserslao();
                        } else {
                          toast.info('No verified measurements to send.');
                        }
                      } catch (error) {
                        console.error('Error in surveyor process:', error);
                        toast.error('Error occurred during process. Please try again.');
                      }
                    }}
                    disabled={measurements.filter(m => m.is_surveyorVerified === true).length === 0}
                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${measurements.filter(m => m.is_surveyorVerified === true).length === 0
                        ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                        : hasFirstSentToLAO
                          ? 'bg-red-600 text-white hover:bg-red-700'
                          : 'bg-blue-600 text-white hover:bg-blue-700'
                      }`}
                  >
                    <Send className="mr-2 h-5 w-5" />
                    <span>{translations[language].SendToLAOOfficer} ({measurements.filter(m => m.is_surveyorVerified === true).length})</span>
                  </button> */}

                  {/* Send Back to DSLR Button */}
                  <button
                    onClick={async () => {
                      const totalMeasurements = measurements.length;
                      const completedCount = measurements.filter(m => m.is_surveyorVerified === true).length;

                      // NEW VALIDATION: Must be ALL completed
                      if (completedCount !== totalMeasurements) {
                        toast.warning(`Cannot send partial batch. ${completedCount}/${totalMeasurements} measurements completed. Finish all measurements first.`);
                        return;
                      }

                      if (completedCount > 0) {
                        setShowRoleModal(true);
                      } else {
                        toast.info('No completed measurements to send.');
                      }
                    }}

                    // NEW DISABLE CONDITION: Only enabled if ALL are completed
                    disabled={
                      measurements.length === 0 ||
                      measurements.filter(m => m.is_surveyorVerified === true).length !== measurements.length
                    }

                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${measurements.length === 0 ||
                      measurements.filter(m => m.is_surveyorVerified === true).length !== measurements.length
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                      : hasFirstSentToDSLR
                        ? 'bg-red-600 text-white hover:bg-red-700'
                        : 'bg-yellow-600 text-white hover:bg-yellow-700'
                      }`}
                  >
                    <ArrowLeft className="mr-2 h-5 w-5" />
                    <span>
                      {hasFirstSentToDSLR ? 'Re-send Back to DSLR' : 'Send Back to DSLR'} (All {measurements.length})
                    </span>
                  </button>
                </div>
              )}

              {(userRole === USER_ROLES.DSLR) && !hasSentBackToSLR && (
                <div className="flex items-center gap-4">
                  {/* Send to LAO Button */}
                  {/* <button
                    onClick={async () => {
                      try {
                        const slrVerifiedCount = measurements.filter(m => m.is_SLRVerified === true).length;

                        if (slrVerifiedCount > 0) {
                          setShowSendToLAOModal(true);
                          await fetchUserslao();
                        } else {
                          toast.info('No verified measurements to send to LAO.');
                        }
                      } catch (error) {
                        console.error('Error in DSLR send to LAO:', error);
                        toast.error('Error occurred during process. Please try again.');
                      }
                    }}
                    disabled={measurements.filter(m => m.is_SLRVerified === true).length === 0}
                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${measurements.filter(m => m.is_SLRVerified === true).length === 0
                        ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                        : hasFirstSentToLAO
                          ? 'bg-red-600 text-white hover:bg-red-700'
                          : 'bg-blue-600 text-white hover:bg-blue-700'
                      }`}
                  >
                    <Send className="mr-2 h-5 w-5" />
                    <span>{translations[language].SendVerifiedToLAOOfficer} ({measurements.filter(m => m.is_SLRVerified === true).length})</span>
                  </button> */}

                  {/* Send Back to LAO Button */}
                  <button
                    onClick={async () => {
                      const totalMeasurements = measurements.length;
                      const verifiedCount = measurements.filter(m => m.is_SLRVerified === true).length;

                      // NEW VALIDATION: Must be ALL verified
                      if (verifiedCount !== totalMeasurements) {
                        toast.warning(`Cannot send partial batch. ${verifiedCount}/${totalMeasurements} measurements verified. Verify all measurements first.`);
                        return;
                      }

                      if (verifiedCount > 0) {
                        setShowSendBackToLAOModal(true);
                        await fetchUserslao();
                      } else {
                        toast.info('No verified measurements to send back to LAO.');
                      }
                    }}

                    // NEW DISABLE CONDITION: Only enabled if ALL are verified
                    disabled={
                      measurements.length === 0 ||
                      measurements.filter(m => m.is_SLRVerified === true).length !== measurements.length
                    }

                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${measurements.length === 0 ||
                      measurements.filter(m => m.is_SLRVerified === true).length !== measurements.length
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                      : hasFirstSentToLAO
                        ? 'bg-red-600 text-white hover:bg-red-700'
                        : 'bg-yellow-600 text-white hover:bg-yellow-700'
                      }`}
                  >
                    <ArrowLeft className="mr-2 h-5 w-5" />
                    <span>
                      {hasFirstSentToLAO ? 'Re-send Back to LAO' : 'Send Back to LAO'} (All {measurements.length})
                    </span>
                  </button>

                  {/* Assign to Surveyor Button */}
                  <button
                    onClick={async () => {
                      const totalMeasurements = measurements.length;
                      const unassignedCount = measurements.filter(m =>
                        m.is_SLRVerified === null && m.is_surveyorVerified === null
                      ).length;

                      // NEW VALIDATION: Must be ALL unassigned
                      if (unassignedCount !== totalMeasurements) {
                        toast.warning(`Cannot assign partial batch. ${unassignedCount}/${totalMeasurements} measurements are ready. Complete all measurements first.`);
                        return;
                      }

                      if (unassignedCount > 0) {
                        setShowRoleModal(true);
                      } else {
                        toast.info('No measurements available to assign.');
                      }
                    }}

                    // NEW DISABLE CONDITION: Only enabled if ALL are unassigned
                    disabled={
                      measurements.length === 0 ||
                      measurements.filter(m => m.is_SLRVerified === null && m.is_surveyorVerified === null).length !== measurements.length
                    }

                    className={`flex items-center px-6 py-3 font-semibold rounded-xl shadow-lg transition-all duration-200 ${measurements.length === 0 ||
                      measurements.filter(m => m.is_SLRVerified === null && m.is_surveyorVerified === null).length !== measurements.length
                      ? 'bg-gray-400 text-gray-600 cursor-not-allowed'
                      : hasFirstSentToSurveyor
                        ? 'bg-red-600 text-white hover:bg-red-700'
                        : 'bg-green-600 text-white hover:bg-green-700'
                      }`}
                  >
                    <Send className="mr-2 h-5 w-5" />
                    <span>
                      {hasFirstSentToSurveyor ? 'Re-assign to Surveyor' : 'Assign to Surveyor'} (All {measurements.length})
                    </span>
                  </button>
                </div>
              )}

            </div>
          </div>
        </div>
      </div>

      {/* Surveyor Second Assignment Confirmation Modal */}
      {showSurveyorConfirmModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <div className="flex items-center mb-4">
              <div className="bg-amber-100 p-2 rounded-full mr-3">
                <svg className="w-6 h-6 text-amber-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800">{translations[language].ReassignToSurveyor}</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">
              {translations[language].ReassignConfirmation}
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={() => setShowSurveyorConfirmModal(false)}
              >
                {translations[language].Cancel}
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={async () => {
                  setShowSurveyorConfirmModal(false);
                  setShowSendToSurveyorModal(true);
                  await fetchUsers(); // Fetch Surveyors
                }}
              >
                {translations[language].YesReassign}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Collapsible Filter Panel */}
      {showFilterPanel && (
        <div className="bg-white border-b border-gray-200 shadow-sm">
          <div className="container mx-auto px-6 py-6">
            <div className="space-y-6">
              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                {/* Filter Mode Selection */}
                <div className="flex items-center justify-between">
                  <div className="flex items-center space-x-1 bg-gray-100 rounded-xl p-1.5 shadow-inner">
                    <button
                      onClick={() => setFilterMode('location')}
                      className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'location'
                        ? 'bg-white text-blue-600 shadow-sm'
                        : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                        }`}
                    >
                      <MapPin className="h-4 w-4" />
                      <span>{translations[language].FilterByLocation}</span>
                    </button>
                    <button
                      onClick={() => setFilterMode('all')}
                      className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 flex items-center space-x-2 ${filterMode === 'all'
                        ? 'bg-white text-blue-600 shadow-sm'
                        : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                        }`}
                    >
                      <Globe className="h-4 w-4" />
                      <span>{translations[language].AllRecords}</span>
                    </button>
                  </div>
                </div>
              </div>

              {/* Location Filters - Only show when location mode is selected */}
              {filterMode === 'location' && (
                <div className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <MapPin className="h-5 w-5 text-blue-600 mr-2" />
                      <h3 className="text-lg font-semibold text-gray-800">{translations[language].SelectLocation}</h3>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      {/* District Dropdown */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].District}
                        </label>
                        <select
                          value={selectedDistrict}
                          onChange={handleDistrictChange}
                          disabled={loadingDistricts}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                        >
                          <option value="">
                            {loadingDistricts ? <span>{translations[language].LoadingDistricts}</span> : <span>{translations[language].SelectDistrict}</span>}
                          </option>
                          {districts.map((district, index) => (
                            <option key={district.dist_name || index} value={district.dist_name}>
                              {district.dist_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Taluka Dropdown */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].Taluka}
                        </label>
                        <select
                          value={selectedTaluka}
                          onChange={handleTalukaChange}
                          disabled={!selectedDistrict || loadingTalukas}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                        >
                          <option value="">
                            {loadingTalukas ? <span>{translations[language].LoadingTalukas}</span> : <span>{translations[language].SelectTaluka}</span>}
                          </option>
                          {talukas.map((taluka, index) => (
                            <option key={taluka.taluka_name || index} value={taluka.taluka_name}>
                              {taluka.taluka_name}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Village Dropdown */}
                      <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          {translations[language].Village}
                        </label>
                        <select
                          value={selectedVillage}
                          onChange={handleVillageChange}
                          disabled={!selectedTaluka || loadingVillages}
                          className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed transition-all duration-200 shadow-sm"
                        >
                          <option value="">
                            {loadingVillages ? <span>{translations[language].LoadingVillages}</span> : <span>{translations[language].SelectVillage}</span>}
                          </option>
                          {villages.map((village, index) => (
                            <option key={village.village_name || index} value={village.village_name}>
                              {village.village_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                    {filterMode === 'location' && !selectedDistrict && (
                      <div className="bg-amber-50 border border-amber-200 rounded-lg p-3">
                        <p className="text-sm text-amber-700">
                          {translations[language].SelectDistrictNote}
                        </p>
                      </div>
                    )}
                    {filterMode === 'location' && selectedDistrict && (
                      <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                        <p className="text-sm text-green-700 flex items-center">
                          <span className="mr-2">✓</span>
                          {translations[language].ShowingDataFor}: {getCurrentLocationDescription()}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* All Records Info */}
              {filterMode === 'all' && (
                <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <svg className="h-5 w-5 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div className="ml-3">
                      <p className="text-sm text-blue-700">
                        {translations[language].ShowingAllMeasurements}
                      </p>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Measurement Table View */}
      {canShowData && (
        <div className="overflow-x-auto mt-6 bg-white rounded-lg shadow-md">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-100">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].SurveyNo}</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].LandAcquisitionID}</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].LandHolderName}</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].TotalArea}</th>
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].AquiredArea}</th>
                {filterMode === 'all' && (
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].Location}</th>
                )}
                {userRole === USER_ROLES.DSLR && ( // DSLR (Document Verification Officer)
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].Verification}</th>
                )}
                {userRole === USER_ROLES.SURVEYOR && ( // Surveyor
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].Completed}</th>
                )}
                <th className="px-4 py-3 text-left text-sm font-semibold text-gray-700">{translations[language].AddDetails}</th>
              </tr>
            </thead>

            <tbody className="divide-y divide-gray-200">
              {loadingMeasurements ? (
                <tr>
                  {/* Update the colspan to account for the new Actions column */}
                  <td colSpan={
                    filterMode === 'all'
                      ? (userRole === USER_ROLES.DSLR ? "8" : userRole === USER_ROLES.LAO ? "8" : "7")
                      : (userRole === USER_ROLES.DSLR ? "7" : userRole === USER_ROLES.LAO ? "7" : "6")
                  } className="px-4 py-8 text-center text-gray-500">
                    <div className="flex justify-center items-center h-80">
                      <div className="text-center animate-float">
                        <div className="inline-flex relative">
                          <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
                          <div
                            className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0"
                            style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}
                          ></div>
                          <div className="absolute inset-0 flex items-center justify-center">
                            <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
                          </div>
                        </div>
                        <p className="text-gray-400 mt-4">{translations[language].LoadingMeasurements}</p>
                      </div>
                    </div>
                    <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>
                  </td>
                </tr>
              ) : measurements.length > 0 ? (
                measurements.map((measurement, index) => (
                  <tr key={measurement.land_owner_id || measurement.LandAcquisition_id || index} className="hover:bg-gray-50">
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                      {measurement.survey_no || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                      {measurement.LandAcquisition_id || 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800">
                      {measurement.landholder_name && measurement.landholder_name.length > 35
                        ? `${measurement.landholder_name.slice(0, 35)}...`
                        : (measurement.landholder_name || 'N/A')}
                    </td>

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-blue-700 font-semibold">
                      {measurement.total_area ? `${measurement.total_area}` : 'N/A'}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap text-sm text-blue-700 font-semibold">
                      {measurement.aqr_area ? `${measurement.aqr_area}` : 'N/A'}
                    </td>

                    {/* Location Column for All Records */}
                    {filterMode === 'all' && (
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-600">
                        {measurement.village || 'N/A'}, {measurement.taluka || 'N/A'}, {measurement.district || 'N/A'}
                      </td>
                    )}

                    {/* DSLR Verification Column */}
                    {userRole === USER_ROLES.DSLR && (
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 align-middle">                        {/* FIXED LOGIC: Surveyor works first, then DSLR verifies */}
                        {measurement.is_SLRVerified === null && measurement.is_surveyorVerified === null ? (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                            <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {translations[language].AwaitingSurveyorCompletion}
                          </span>
                        ) : /* Show verify button when surveyor has completed */
                          measurement.is_surveyorVerified === true && measurement.is_SLRVerified === null ? (
                            <button
                              onClick={() => handleVerification(measurement)}
                              disabled={loading}
                              className="bg-orange-600 hover:bg-orange-700 disabled:bg-gray-400 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1"
                            >
                              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                              </svg>
                              {loading ? <span>{translations[language].Verifying}</span> : <span>{translations[language].Verify}</span>}
                            </button>
                          ) : /* Show verified when DSLR has verified */
                            measurement.is_SLRVerified === true ? (
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                {translations[language].Verified}
                              </span>
                            ) : (
                              /* Default processing state */
                              <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-600">
                                <svg className="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                                {translations[language].Processing}
                              </span>
                            )}
                      </td>
                    )}

                    {/* Surveyor Completion Column */}
                    {userRole === USER_ROLES.SURVEYOR && (
                      <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 align-middle">                        {/* FIXED LOGIC: Surveyor can work first, then DSLR verifies */}
                        {measurement.is_surveyorVerified === true ? (
                          <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800">
                            <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                            {translations[language].Completed}
                          </span>
                        ) : (
                          <button
                            onClick={() => handleSurveyorVerification(measurement)}
                            disabled={loading}
                            className="bg-green-600 hover:bg-green-700 disabled:bg-gray-400 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            {loading ? <span>{translations[language].completing}</span> : <span>{translations[language].Verify}</span>}
                          </button>
                        )}
                      </td>
                    )}

                    <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-800 align-middle">
                      <div className="flex gap-2">
                        {userRole === USER_ROLES.SURVEYOR ? (
                          // Only Surveyor sees "Add Details" button
                          <button
                            onClick={() => handleViewDetails(measurement)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1 transition-all duration-200"
                          >
                            <Edit className="w-4 h-4" />
                            Add Details
                          </button>
                        ) : (
                          // All other roles see "View" button
                          <button
                            onClick={() => handleViewDetails(measurement)}
                            className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded-md text-sm flex items-center gap-1 transition-all duration-200"
                          >
                            <Eye className="w-4 h-4" />
                            View
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={filterMode === 'all' ? (userRole === USER_ROLES.DSLR ? "8" : "7") : (userRole === USER_ROLES.DSLR ? "7" : "6")} className="px-4 py-8 text-center text-gray-500">
                    <div className="flex flex-col items-center gap-2">
                      <FileText className="w-12 h-12 text-gray-300" />
                      <p>{translations[language].NoMeasurementData}</p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Show message when filter mode is location but selection is incomplete */}
      {filterMode === 'location' && !selectedDistrict && (
        <div className="mt-6 text-center py-12">
          <div className="max-w-md mx-auto">
            <MapPin className="h-16 w-16 text-gray-300 mx-auto mb-4" />
            <p className="text-gray-500 text-lg font-medium mb-2">{translations[language].DistrictSelectionRequired}</p>
            <p className="text-gray-400 text-sm">{translations[language].DistrictSelectionNote}</p>
          </div>
        </div>
      )}


      {/* All existing modals remain the same */}
      {showSendToSLRModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">{translations[language].SendToDSLROfficer}</h3>
                <button
                  onClick={() => setShowSendToLAOModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-blue-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                    </div>
                  );
                })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                </div>


                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectUserDSLR} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Remarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={translations[language].EnterRemarks}
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendToLAOModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendToSLR}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language].SendToDSLR}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to LAO Modal */}
      {showSendToLAOModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">{translations[language].SendToLAOOfficer}</h3>
                <button
                  onClick={() => setShowSendToLAOModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-blue-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                    </div>
                  );
                })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                </div>

                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectLAOOfficer} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Renarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={translations[language].EnterRemarks}
                  />
                </div>


                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendToLAOModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendBackToLao}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language].SendToLAOOfficer}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send Back to LAO Modal */}
      {showSendBackToLAOModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">Send Back to LAO Officer</h3>
                <button
                  onClick={() => setShowSendBackToLAOModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                      <p className="text-sm text-yellow-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-yellow-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                      <p className="text-xs text-yellow-600 mt-1 font-medium">
                        ⚠️ Sending verified measurements back to LAO for review
                      </p>
                      </div>
                      );
                      })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                  <p className="text-xs text-yellow-600 mt-1 font-medium">
                    ⚠️ Sending verified measurements back to LAO for review
                  </p>
                </div>

                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectLAOOfficer} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Remarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    placeholder="Enter reason for sending back to LAO..."
                  />
                </div>


                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendBackToLAOModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendBackToLAO}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <ArrowLeft className="mr-2 h-4 w-4" />
                      Send Back to LAO
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send Back to DSLR Modal */}
      {showSendBackToDSLRModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">Send Back to DSLR Officer</h3>
                <button
                  onClick={() => setShowSendBackToDSLRModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-yellow-50 rounded-lg border border-yellow-200">
                      <p className="text-sm text-yellow-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-yellow-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                      <p className="text-xs text-yellow-600 mt-1 font-medium">
                        ⚠️ Sending completed measurements back to DSLR for review
                      </p>
                      </div>
                      );
                      })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                  <p className="text-xs text-yellow-600 mt-1 font-medium">
                    ⚠️ Sending completed measurements back to DSLR for review
                  </p>

                </div>
                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectUserDSLR} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Remarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    placeholder="Enter reason for sending back to DSLR..."
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendBackToDSLRModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendBackToDSLR}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <ArrowLeft className="mr-2 h-4 w-4" />
                      Send Back to DSLR
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to Surveyor Modal */}
      {showSendToSurveyorModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">{translations[language].SendToSurveyor}</h3>
                <button
                  onClick={() => setShowSendToSurveyorModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-blue-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                    </div>
                  );
                })()} */}
                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                </div>


                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectUserSurveyor} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Remarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={translations[language].EnterRemarks}
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendToSurveyorModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendToSurveyor}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language].SendToSurveyor}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send Back to DSLR Modal */}
      {showSendbackToSLrModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800"> {translations[language].SendBackToDSLR} </h3>
                <button
                  onClick={() => setShowSendbackToSLrModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-blue-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                    </div>
                  );
                })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                </div>


                {/* User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectUserDSLR} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].Remarks}
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={translations[language].EnterRemarks}
                  />
                </div>

                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendToLAOModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToLAO}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendBackToSlr}
                  disabled={sendingToLAO || !selectedUser || !selectedDocument}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToLAO ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language].SendBackToDSLRText}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Send to Agency Modal */}
      {showSendToAgencyModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-xl font-semibold text-gray-800">{translations[language].SendToConcernValuer}</h3>
                <button
                  onClick={() => setShowSendToAgencyModal(false)}
                  className="text-gray-400 hover:text-gray-600"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="space-y-4">
                {/* Project Info */}
                {/* {(() => {
                  const selectedProject = JSON.parse(localStorage.getItem('selectedProject') || '{}');
                  return (
                    <div className="p-3 bg-blue-50 rounded-lg">
                      <p className="text-sm text-blue-800">
                        <strong>{translations[language].Project}:</strong> {selectedProject?.project_name}
                      </p>
                      <p className="text-xs text-blue-600">
                        {translations[language].ID}: {selectedProject?.id || selectedProject?.project_id}
                      </p>
                    </div>
                  );
                })()} */}

                <div className="p-3 bg-blue-50 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>{translations[language].Project}:</strong> {currentProjectName}
                  </p>
                  <p className="text-xs text-blue-600">
                    {translations[language].ID}: {currentProjectId}
                  </p>
                </div>


                {/* Agency User Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].SelectConcernValuerUser} *
                  </label>
                  <select
                    value={selectedUser}
                    onChange={(e) => setSelectedUser(e.target.value)}
                    disabled={loadingUsers}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  >
                    <option value="">
                      {loadingUsers ? <span>{translations[language].loading_officers}</span> : <span>{translations[language].select_officer}</span>}
                    </option>
                    {users.map((user) => (
                      <option key={user.id || user.usr_id} value={user.id || user.usr_id}>
                        {user.full_name || user.user_name} ({user.usr_role})
                      </option>
                    ))}
                  </select>
                </div>

                {/* Remarks */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">{translations[language].Remarks}</label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    rows={3}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                    placeholder={translations[language].EnterRemarks}
                  />
                </div>


                {/* Document Upload */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    {translations[language].UploadDocument} *
                  </label>
                  <input
                    type="file"
                    onChange={(e) => setSelectedDocument(e.target.files[0])}
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-yellow-500 focus:border-yellow-500"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  {selectedDocument && (
                    <div className="mt-2 flex items-center justify-between p-2 bg-green-50 rounded-lg">
                      <p className="text-xs text-green-600">
                        {translations[language].Selected}: {selectedDocument.name}
                      </p>
                      <button
                        type="button"
                        onClick={() => handleViewDocument(selectedDocument)}
                        className="px-3 py-1 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 flex items-center"
                      >
                        <Eye className="h-3 w-3 mr-1" />
                        {translations[language].View}
                      </button>
                    </div>
                  )}
                </div>
              </div>

              {/* Modal Actions */}
              <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
                <button
                  onClick={() => setShowSendToAgencyModal(false)}
                  className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                  disabled={sendingToAgency}
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={handleSendToAgency}
                  disabled={sendingToAgency}
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center"
                >
                  {sendingToAgency ? (
                    <>
                      <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                      {translations[language].Sending}
                    </>
                  ) : (
                    <>
                      <Send className="mr-2 h-4 w-4" />
                      {translations[language].SendToConcernValuer}
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Document Preview Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl p-4 w-full max-w-5xl h-[90vh] shadow-xl overflow-hidden">
            {/* Header */}
            <div className="flex justify-between items-center mb-2">
              <h3 className="text-xl font-semibold text-gray-800">{translations[language].DocumentPreview}</h3>
              <button
                onClick={() => {
                  setShowModal(false);
                  URL.revokeObjectURL(documentUrl);
                }}
                className="text-gray-400 hover:text-gray-700 text-2xl font-bold"
              >
                ×
              </button>
            </div>

            {/* Document Viewer */}
            <iframe
              src={documentUrl}
              className="w-full h-[80vh] rounded border border-gray-300"
              title="Document Preview"
            />
          </div>
        </div>
      )}

      {/* Section 19 Modal */}
      {showSection19Modal && (
        <Section19
          projectId={currentProjectId}
          proposalId={proposalId}
          onClose={() => setShowSection19Modal(false)}
        />
      )}

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-md">
            <div className="flex items-center mb-4">
              <div className="bg-red-100 p-2 rounded-full mr-3">
                <svg className="w-6 h-6 text-red-600" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M18 10c0 4.418-3.582 8-8 8s-8-3.582-8-8 3.582-8 8-8 8 3.582 8 8zm-8 3a1 1 0 100-2 1 1 0 000 2zm1-7H9v4h2V6z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-800">{translations[language].ProceedConfirmation}</h3>
            </div>
            <p className="text-sm text-gray-600 mb-6">
              {translations[language].ProceedNote}
            </p>
            <div className="flex justify-end gap-3">
              <button
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded hover:bg-gray-200"
                onClick={() => setShowConfirmationModal(false)}
              >
                {translations[language].No}
              </button>
              <button
                className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                onClick={() => {
                  setShowConfirmationModal(false);
                  if (onConfirmAction) onConfirmAction();
                }}
              >
                {translations[language].YesContinue}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Simple Alert Notification */}
      {showAlertModal && (
        <div className="fixed top-4 right-4 z-50">
          <div className={`bg-white rounded-lg shadow-lg border-l-4 p-4 max-w-sm ${alertConfig.type === 'error' ? 'border-red-500' :
            alertConfig.type === 'warning' ? 'border-yellow-500' :
              alertConfig.type === 'info' ? 'border-blue-500' :
                'border-green-500'
            }`}>
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${alertConfig.type === 'error' ? 'bg-red-100' :
                  alertConfig.type === 'warning' ? 'bg-yellow-100' :
                    alertConfig.type === 'info' ? 'bg-blue-100' :
                      'bg-green-100'
                  }`}>
                  <span className={`font-bold ${alertConfig.type === 'error' ? 'text-red-600' :
                    alertConfig.type === 'warning' ? 'text-yellow-600' :
                      alertConfig.type === 'info' ? 'text-blue-600' :
                        'text-green-600'
                    }`}>
                    {alertConfig.type === 'error' ? '✕' :
                      alertConfig.type === 'warning' ? '⚠' :
                        alertConfig.type === 'info' ? 'ℹ' : '✓'}
                  </span>
                </div>
              </div>
              <div className="ml-3 flex-1">
                <h3 className="text-sm font-medium text-gray-900">{alertConfig.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{alertConfig.message}</p>
              </div>
              <button
                onClick={() => setShowAlertModal(false)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Role-based Pre-Modal for DSLR / Surveyor */}
      {showRoleModal && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-4xl">
            <h3 className="text-lg font-semibold mb-4">
              {userRole === USER_ROLES.DSLR ? "भुकरमापक नेमणे (Assign to Surveyor)" : "उपअधीक्षक भूमी अभिलेख परत (Send Completed to DSLR)"}
            </h3>

            <div className="overflow-x-auto">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-2 text-left font-medium">{translations[language].landSerialNo}</th>
                    <th className="border border-gray-300 px-4 py-2 text-center font-medium">{translations[language].Matter}</th>
                    <th className="border border-gray-300 px-4 py-2 text-center font-medium">{translations[language].Remarks}</th>
                  </tr>
                </thead>
                <tbody>
                  {userRole === USER_ROLES.DSLR && (
                    <>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">1</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].AppointLandSurveyor} <span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <select
                            required
                            value={roleFormData.dlsr_appoint_surveyor || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, dlsr_appoint_surveyor: e.target.value })}
                            disabled={loadingUsers}
                            className="w-full border p-2 rounded"
                          >
                            <option value=""> {translations[language].SelectUserSurveyor}</option>
                            {users.map((u) => (
                              <option key={u.id || u.usr_id} value={u.id || u.usr_id}>
                                {(u.full_name || u.user_name) + (u.usr_role ? ` (${u.usr_role})` : "")}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">2</td>
                        <td className="border border-gray-300 px-4 py-2 text-center"> {translations[language].landAcquisitionAuthorityEcounting}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="date"
                            required
                            min="1990-01-01"
                            max="2050-12-31"
                            defaultValue={new Date().toISOString().split('T')[0]}
                            placeholder="भूसंपादन यंत्रणेने ई मोजणी प्रणालीत मोजणी अर्ज"
                            value={roleFormData.dlsr_survey_application_date || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, dlsr_survey_application_date: e.target.value })}
                            className="w-full border p-2 rounded"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">3</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].feeCollectedByLandAcquisition} <span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            required
                            min="0"
                            step="0.01"
                            placeholder={translations[language].feeCollectedByLandAcquisition}
                            value={roleFormData.dlsr_gov_fee_paid_for_survey || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, dlsr_gov_fee_paid_for_survey: e.target.value })}
                            className="w-full border p-2 rounded"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">4</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].DatePaymentFeeCollected} <span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <div className="space-y-2">
                            <input
                              type="date"
                              required
                              min="1990-01-01"
                              max="2050-12-31"
                              defaultValue={new Date().toISOString().split('T')[0]}
                              placeholder={translations[language].DatePaymentFeeCollected}
                              value={roleFormData.dlsr_gov_fee_payment_date || ""}
                              onChange={e => setRoleFormData({ ...roleFormData, dlsr_gov_fee_payment_date: e.target.value })}
                              className="w-full border p-2 rounded"
                            />
                            <input
                              type="file"
                              required
                              accept=".pdf,.jpg,.jpeg,.png"
                              onChange={e => setRoleFile(e.target.files[0])}
                              className="w-full border p-2 rounded text-sm"
                            />
                            {proposalData?.dlsr_gov_fee_payment_img && (
                              <a
                                href={proposalData.dlsr_gov_fee_payment_img}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="block text-blue-600 underline text-sm"
                              >
                                View Uploaded File
                              </a>
                            )}
                          </div>
                        </td>
                      </tr>
                    </>
                  )}

                  {userRole === USER_ROLES.SURVEYOR && (
                    <>
                      {/* First column "1" will span all 3 rows */}
                      <tr>
                        <td
                          className="border border-gray-300 px-4 py-2 text-center align-top"
                          rowSpan={3}
                        >
                          1
                        </td>

                        {/* "Joint Census Date" spans across the next 2 columns */}
                        <td
                          className="border border-gray-300 px-4 py-2 text-center font-semibold"
                          colSpan={1}
                        >
                          {translations[language].JointCensudDate}
                          <span className="text-red-600">*</span>
                        </td>
                      </tr>

                      {/* Start Date Row */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          Start Date </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="date"
                            required
                            min="1990-01-01"
                            max="2050-12-31"
                            value={
                              roleFormData.surveyor_joint_start_date ||
                              new Date().toISOString().split("T")[0]
                            }
                            onChange={e =>
                              setRoleFormData({
                                ...roleFormData,
                                surveyor_joint_start_date: e.target.value,
                              })
                            }
                            className="w-full border p-2 rounded"
                          />
                        </td>
                      </tr>

                      {/* End Date Row */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          End Date
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="date"
                            required
                            min="1990-01-01"
                            max="2050-12-31"
                            value={
                              roleFormData.surveyor_joint_end_date ||
                              new Date().toISOString().split("T")[0]
                            }
                            onChange={e =>
                              setRoleFormData({
                                ...roleFormData,
                                surveyor_joint_end_date: e.target.value,
                              })
                            }
                            className="w-full border p-2 rounded"
                          />
                        </td>
                      </tr>

                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">2</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].JointRepresentatives}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <select
                            required
                            value={roleFormData.surveyor_present_officials_name_designation || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, surveyor_present_officials_name_designation: e.target.value })}
                            disabled={loadingUsers}
                            className="w-full border p-2 rounded"
                          >
                            <option value=""> {translations[language].SelectUserDSLR}</option>
                            {users.map((u) => (
                              <option key={u.id || u.usr_id} value={u.id || u.usr_id}>
                                {(u.full_name || u.user_name) + (u.usr_role ? ` (${u.usr_role})` : "")}
                              </option>
                            ))}
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">3</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].GeoTaggedPhoto} <span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="file"
                            required
                            accept=".pdf,.jpg,.jpeg,.png"
                            onChange={e => setRoleFile(e.target.files[0])}
                            className="w-full border p-2 rounded text-sm"
                          />
                          {proposalData?.surveyor_geo_tagged_image && (
                            <a
                              href={proposalData.surveyor_geo_tagged_image}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="block text-blue-600 underline text-sm mt-2"
                            >
                              View Uploaded File
                            </a>
                          )}
                        </td>
                      </tr>
                      {/* 4 */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">4</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].MRNo}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            required
                            value={roleFormData.surveyor_m_r_no || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, surveyor_m_r_no: e.target.value })}
                            disabled={loadingUsers}
                            className="w-full border p-2 rounded"
                          >
                          </input>
                        </td>
                      </tr>
                      {/* 5 */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">5</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].BhusampadanNo}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            required
                            value={roleFormData.section_11_bhusampadan_no || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, section_11_bhusampadan_no: e.target.value })}
                            className="w-full border p-2 rounded"                          >
                          </input>
                        </td>
                      </tr>
                      {/* 6 */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">6</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].AcquisitionAgency}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            required
                            value={roleFormData.acquisition_agency || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, acquisition_agency: e.target.value })}
                            className="w-full border p-2 rounded"
                          >
                          </input>
                        </td>
                      </tr>
                      {/* 7 */}
                      <tr>
                        <td className="border border-gray-300 px-4 py-2 text-center">7</td>
                        <td className="border border-gray-300 px-4 py-2 text-center">{translations[language].PurposeOfLandAcquisition}<span className="text-red-600">*</span></td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            required
                            value={roleFormData.acquisition_purpose || ""}
                            onChange={e => setRoleFormData({ ...roleFormData, acquisition_purpose: e.target.value })}
                            className="w-full border p-2 rounded"
                          >
                          </input>
                        </td>
                      </tr>

                    </>
                  )}
                </tbody>
              </table>
            </div>

            <div className="mt-6 flex justify-end gap-3">
              <button onClick={() => setShowRoleModal(false)} className="px-4 py-2 bg-gray-200 rounded">
                Cancel
              </button>
              <button
                onClick={async () => {
                  try {
                    setSubmitting(true); // 🔹 disable + show loading
                    const formData = new FormData();
                    if (roleFile) {
                      const fileFieldName =
                        userRole === USER_ROLES.DSLR
                          ? "dlsr_gov_fee_payment_img"
                          : "surveyor_geo_tagged_image";
                      formData.append(fileFieldName, roleFile);
                    }
                    // Role-based payload
                    if (userRole === USER_ROLES.DSLR) {
                      if (roleFormData.dlsr_appoint_surveyor)
                        formData.append("dlsr_appoint_surveyor", roleFormData.dlsr_appoint_surveyor);
                      if (roleFormData.dlsr_survey_application_date)
                        formData.append("dlsr_survey_application_date", roleFormData.dlsr_survey_application_date);
                      if (roleFormData.dlsr_gov_fee_paid_for_survey)
                        formData.append("dlsr_gov_fee_paid_for_survey", roleFormData.dlsr_gov_fee_paid_for_survey);
                      if (roleFormData.dlsr_gov_fee_payment_date)
                        formData.append("dlsr_gov_fee_payment_date", roleFormData.dlsr_gov_fee_payment_date);
                    }

                    if (userRole === USER_ROLES.SURVEYOR) {
                      // ✅ Always send both dates (even if empty string)
                      formData.set("surveyor_joint_start_date", roleFormData.surveyor_joint_start_date || "");
                      formData.set("surveyor_joint_end_date", roleFormData.surveyor_joint_end_date || "");
                      // if (roleFormData.surveyor_joint_start_date)
                      //   formData.append("surveyor_joint_start_date", roleFormData.surveyor_joint_start_date);
                      // if (roleFormData.surveyor_joint_end_date)
                      //   formData.append("surveyor_joint_end_date", roleFormData.surveyor_joint_end_date);
                      if (roleFormData.surveyor_present_officials_name_designation)
                        formData.append("surveyor_present_officials_name_designation", roleFormData.surveyor_present_officials_name_designation);
                      if (roleFormData.surveyor_m_r_no)
                        formData.append("surveyor_m_r_no", roleFormData.surveyor_m_r_no);
                      if (roleFormData.section_11_bhusampadan_no)
                        formData.append("section_11_bhusampadan_no", roleFormData.section_11_bhusampadan_no);
                      if (roleFormData.acquisition_agency)
                        formData.append("acquisition_agency", roleFormData.acquisition_agency);
                      if (roleFormData.acquisition_purpose)
                        formData.append("acquisition_purpose", roleFormData.acquisition_purpose);
                    }
                    const res = await apiService.updateProposalPublish(proposalId, formData);
                    if (res.ok) {
                      toast.success("Sent successfully!");
                      setShowRoleModal(false);
                      if (userRole === USER_ROLES.DSLR) {
                        // Prefill the selected surveyor in the next modal
                        setSelectedUser(roleFormData.dlsr_appoint_surveyor || "");
                        setShowSendToSurveyorModal(true);
                        await fetchUsers();
                      }
                      if (userRole === USER_ROLES.SURVEYOR) {
                        // Prefill the selected DSLR official in the next modal  
                        setSelectedUser(roleFormData.surveyor_present_officials_name_designation || "");
                        setShowSendbackToSLrModal(true);
                        await fetchUsersSlr();
                      }
                    }
                  } catch (err) {
                    toast.error("Failed to save!");
                  } finally {
                    setSubmitting(false); // 🔹 re-enable
                  }
                }}
                disabled={submitting} // 🔹 disable while loading
                className={`px-4 py-2 rounded text-white ${submitting ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600"
                  }`}
              >
                {submitting ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Simple Confirmation Modal */}
      {showConfirmModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-sm mx-4">
            <div className="p-6">
              <div className={`w-12 h-12 rounded-full mx-auto mb-4 flex items-center justify-center ${confirmConfig.type === 'danger' ? 'bg-red-100' :
                confirmConfig.type === 'warning' ? 'bg-yellow-100' :
                  'bg-blue-100'
                }`}>
                {confirmConfig.type === 'danger' ? '⚠' :
                  confirmConfig.type === 'warning' ? '⚠' : '?'}
              </div>

              <h3 className="text-lg font-semibold text-gray-900 mb-2 text-center">
                {confirmConfig.title}
              </h3>

              <p className="text-gray-600 text-sm mb-6 text-center">
                {confirmConfig.message}
              </p>

              <div className="flex gap-3">
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onCancel) confirmConfig.onCancel();
                  }}
                  className="flex-1 py-2 px-4 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 transition-colors"
                >
                  {translations[language].Cancel}
                </button>
                <button
                  onClick={() => {
                    setShowConfirmModal(false);
                    if (confirmConfig.onConfirm) confirmConfig.onConfirm();
                  }}
                  className={`flex-1 py-2 px-4 text-white rounded-md transition-colors ${confirmConfig.type === 'danger' ? 'bg-red-600 hover:bg-red-700' :
                    confirmConfig.type === 'warning' ? 'bg-yellow-600 hover:bg-yellow-700' :
                      'bg-blue-600 hover:bg-blue-700'
                    }`}
                >
                  {translations[language].Confirm}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Success/Error Messages */}
      {message && (
        <div className={`fixed top-4 right-4 p-4 rounded-lg shadow-lg z-50 ${message.includes('Error') || message.includes('failed')
          ? 'bg-red-100 border border-red-400 text-red-700'
          : 'bg-green-100 border border-green-400 text-green-700'
          }`}>
          <div className="flex items-center gap-2">
            {message.includes('Error') || message.includes('failed') ? (
              <X className="w-5 h-5" />
            ) : (
              <Check className="w-5 h-5" />
            )}
            <span>{message}</span>
          </div>
        </div>
      )}

    </div>
  );
};

export default MeasurementList;